import { superagent } from '../../shared/superagent/superagent';

import singletons from '../../shared/singletons'
import { MessageComponent } from '../../shared/dialog/message.component'

import { Observable } from 'rxjs'

class OrderApi {
  makeOrder(order, h = {}) {
    return Observable.create((obs)=> {
      singletons['loading'].start()
      superagent.post("/api/orders")
        .send({order: order, params: h})
        .end((err, resp)=> {
          const data = resp.body
          singletons['loading'].stop()
          obs.next(data)
          obs.complete()
        })
    })
  }

  refreshCart(order, payment_type) {
    return Observable.create((obs)=> {
      singletons['loading'].start()
      superagent.post("/cart_json")
        .send({order: order, payment_type: payment_type})
        .end((err, resp)=> {
          const data = resp.body
          singletons['loading'].stop()
          obs.next(data)
          obs.complete()
        })
    })
  }
}

const orderApi = new OrderApi()

export { orderApi };



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/make_order/order_api.js